import PrimaryButton from "../../components/PrimaryButton";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "../../utils/helpers";

const ReplenishmentRequestTable = ({ headers = [], data = [] }) => {
  const navigate = useNavigate();
  return (
    <Table responsive bordered width="100%" cellSpacing={0}>
      <thead>
        <tr>
          {headers?.map((header, index) => (
            <th key={index}>{header?.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map((item, index) => (
          <tr key={index}>
            <td>{item?.request_id}</td>
            <td>{item?.store_name}</td>
            <td>{formatDateTime(item?.created_at)}</td>
            <td>
              <PrimaryButton
                text="View"
                onClick={() =>
                  navigate(`/replenishment-requests/${item.request_id}`)
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ReplenishmentRequestTable;
